module.exports = __webpack_public_path__ + "img/1.455cd41b.png";